import React, { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import StartStep from "./StartStep";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StepFunctions } from "../joyrideSteps";

const WorkScheduleModalStep: React.FC<StepFunctions> = ({ hasExistingSchedule, goToStep }) => {
    const { t } = useTranslation();
    const [showStartStep, setShowStartStep] = useState(false);
    const handleButtonClick = () => setShowStartStep(true);

    useEffect(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }, []);

    const handleSkip = () => {
        goToStep("skip");
    };

    return (
        <>
            {showStartStep ? (
                <StartStep setShowStartStep={setShowStartStep} />
            ) : (
                <>
                    <Row>
                        <Col xs={11}>
                            <span className="fs-normal fw-bold fs-7">{t('Go to \"Creating a work schedule\"')}</span>
                        </Col>
                        <Col xs={1} className="p-0 text-center">
                            <Button variant="link" className="p-0" onClick={handleButtonClick}>
                                <i className="bi bi-x-lg "></i>
                            </Button>
                        </Col>
                    </Row>
                    {hasExistingSchedule && (
                        <Row>
                            <Col className="text-center">
                                <div className="border-top border-secondary border-2 my-3"></div>
                                <Button variant="link" className="py-1" onClick={handleSkip} role="link">
                                    {t("Skip Creation")}
                                </Button>
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </>
    );
};

export default WorkScheduleModalStep;
